// extracted by mini-css-extract-plugin
module.exports = {"container":"container--hcLx6","body":"body--3uLdN"};